<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <loader v-show="loading" />
        <CCardHeader>
          <h5>Soal</h5>
        </CCardHeader>
        <CCardBody>
          <textarea id="question"></textarea>
					<div class="form-inline">
						<label><strong>Import dari HTML</strong></label>
						<file-upload :config="fileUploadConfig" @success="successUploadHtml" @error="errorUploadHtml"/>
					</div>
          <hr>
          <h5>Jawaban</h5>
          <ol type="A" style="padding-left: 18px">
            <li
              v-for="(v, k) in data.answers"
              :key="k"
              style="padding-bottom: 10px"
            >
              <textarea :id="`answer-${k}`" v-html="v.answer"></textarea>
              <div role="group" class="form-check form-check-inline">
                <input
                  type="checkbox"
                  class="form-check-input"
                  value="false"
                  v-model="v.correct_answer"
                /><label class="form-check-label"> Jawaban Benar </label>
              </div>
              <btn-delete @click="removeAnswer(k)" label="Hapus Jawaban" />
              <hr>
            </li>
          </ol>
          <btn-add label="Tambah Jawaban" @click="addNewAnswer" />
        </CCardBody>
        <CCardFooter>
          <btn-save-update :data="data" @back="doBack" @save="doSave" @update="doUpdate"/>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
function initSummernote(sel) {
// eslint-disable-next-line no-undef
  $(document).ready(function () {
    // eslint-disable-next-line no-undef
    $(`#${sel}`).summernote({
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['insert', ['picture', 'hr']],
        ['table', ['table']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']],
        ['codeview']
      ],
      height: 200,
      focus: true,
      fontSizes: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18' , '19', '20', '21', '22', '23'],
    });
    // eslint-disable-next-line no-undef
    $('.note-editable').css('font-size','16px');
    // eslint-disable-next-line no-undef
    $('.note-editable').css('font-family','Arial');
  })
}

function getSummernoteVal(sel) {
  // eslint-disable-next-line no-undef
  const html = $(`#${sel}`).summernote('code');
  return html;
}

function setSummernoteVal(sel, val) {
  // eslint-disable-next-line no-undef
  $(`#${sel}`).summernote('code', val);
}

initSummernote('question')
import Loader from '../../components/Loader'
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH, authToken } from '../../lib/httplib';
import BtnDelete from '../../components/BtnDelete'
import BtnAdd from '../../components/BtnAdd'
import BtnSaveUpdate from '../../components/BtnSaveUpdate'
import FileUpload from '../../components/FileUpload'

export default {
  data() {
    return {
      loading: false,
      text: '',
      data: {
        answers: []
      },
      params: {},
      fileUploadConfig: {
        url: process.env.VUE_APP_API_HOST + '/api/v1/admin/import-html',
        headers: {
					"authorization": "Bearer " + authToken(),
          'Content-Type': 'multipart/form-data',
				}
      }
    }
  },
  components: {
    Loader,
    BtnDelete,
    BtnAdd,
    BtnSaveUpdate,
		FileUpload,
  },
  created() {
    initSummernote('question')
    const params = this.$route.params
    if (params) {
      this.params = params;
    }
    if (params && params.id && params.id != 'ya') {
      this.get(params.id)
    }
  },
  methods: {
    get(id) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/admin/question/${id}`).then(res => {
        this.data = res.data.data
        setSummernoteVal('question', this.data.question);
        const answers = this.data.answers;
        for (var i in answers) {
          initSummernote(`answer-${i}`)
          setSummernoteVal(`answer-${i}`, answers[i].answer)
        }
        this.loading = false;
      }).catch(eres => {
        this.loading = false;
        showErrorMessage(eres)
      })
    },
    validate() {
      const params = this.$route.params;
      var answers = this.data.answers;
      for (var i in answers) {
        answers[i].order = parseInt(i) + 1;
        if (answers[i].correct_answer) {
          this.data.correct_answer = answers[i].order;
        }
      }
      if (this.subject && this.subject.id) {
        this.data.subject_id = this.subject.id;
      }
      if (!this.data.correct_answer) {
        this.$toasted.error("Belum ada jawaban benar dipilih").goAway();
        return;
      }
      this.data.answers = answers;
      this.data.question_group_code = params.gcode;
    },
    collectData() {
      this.data.question = getSummernoteVal(`question`)
      for (var i in this.data.answers) {
        this.data.answers[i].answer = getSummernoteVal(`answer-${i}`)
      }
    },
    doSave() {
      this.loading = true;
      this.collectData()
      this.validate()
      HTTPAUTH.post("/api/v1/admin/question", this.data)
        .then(() => {
          this.doBack()
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
          showErrorMessage(eres);
        });
    },
    doUpdate() {
      this.loading = true;
      this.collectData()
      this.validate()
      HTTPAUTH.put("/api/v1/admin/question/" + this.data.slug, this.data)
        .then(() => {
          this.doBack()
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
          showErrorMessage(eres);
        });

    },
    doBack() {
      if (this.params && this.params.gcode) {
        this.$router.push({path: `/soal/tambah/${this.params.gcode}`})
      }
    },
    addNewAnswer() {
      const idx = this.data.answers.length;
      this.data.answers.push({
        order: 0,
        answer: "",
        correct_answer: false,
      });
      initSummernote(`answer-${idx}`)
    },
    removeAnswer(k) {
      this.data.answers.splice(k, 1);
    },
    successUploadHtml(resp) {
      setSummernoteVal("question", resp)
    },
    errorUploadHtml(eres) {
			showErrorMessage(eres)
		}
  }
}
</script>
<style>
.dropzone .dz-preview .dz-image {
  width: 250px;
  height: 250px;
}
</style>